import { render, staticRenderFns } from "./titleAndDescriptionDialog.vue?vue&type=template&id=6aad121c&"
import script from "./titleAndDescriptionDialog.vue?vue&type=script&lang=js&"
export * from "./titleAndDescriptionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aad121c')) {
      api.createRecord('6aad121c', component.options)
    } else {
      api.reload('6aad121c', component.options)
    }
    module.hot.accept("./titleAndDescriptionDialog.vue?vue&type=template&id=6aad121c&", function () {
      api.rerender('6aad121c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/titleAndDescriptionDialog.vue"
export default component.exports